import { useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import Button from 'components/shared/Buttons/Button';
import Modal from 'components/shared/Modal/Modal';
import Allowed from 'components/shared/Permissions/Allowed';

import AddStaffContainer from '../add_staff_container';

const HeaderActions = () => {
  const [showModal, setShowModal] = useState(false);
  const { practice } = useOutletContext();
  const submitStaffRef = useRef();

  return (
    <div>
      <Allowed requiredPermissions="member.create">
        <Button
          text="New staff member"
          icon="add-square-mono"
          size="small"
          transparent
          iconColor="white"
          onClick={() => setShowModal(true)}
          textClassName="whitespace-nowrap"
          data-qa="new-staff-member-btn"
        />
      </Allowed>
      <Modal
        slideFromRight
        handleOpen={showModal}
        handleClose={() => setShowModal(false)}
        footer={
          <div className="flex w-full  justify-between">
            <Button
              data-qa="cancel-btn"
              type="primary"
              color="neutral"
              outlined={true}
              text="Cancel"
              onClick={() => setShowModal(false)}
            />
            <Button
              data-qa="save-btn"
              type="primary"
              text="Save"
              loading={submitStaffRef?.current?.isLoading}
              onClick={() => submitStaffRef?.current?.submitForm()}
            />
          </div>
        }
        title="Personal information">
        <AddStaffContainer
          practice_id={practice.id}
          practice={practice}
          submitStaffRef={submitStaffRef}
          handleSuccess={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          role_list={practice.roles}
        />
      </Modal>
    </div>
  );
};

export default HeaderActions;
